import React from 'react';

import { CmBox } from '@/components/uiParts';
import { DeliveryServiceName } from '@/domain/models/DeliveryService';
import {
  LinkedStoreItem,
  LinkItemsDividedByDeliveryService,
} from '@/domain/models/LinkItem';

import { AccordionHeader, AccordionItem } from './AccordionParts';

interface Props {
  uniqueLinkedStoreItemIdsByGroups: string[];
  isDisabledAddButton: boolean;
  linkItems: LinkItemsDividedByDeliveryService[];
  deliveryServices: DeliveryServiceName[];
  handleToggleAccordion: (deliveryService: DeliveryServiceName) => void;
  handleAddItemToLinkedGroup: (linkedStoreItem: LinkedStoreItem) => void;
}

export const AccordionWrapper: React.FC<Props> = ({
  uniqueLinkedStoreItemIdsByGroups,
  isDisabledAddButton,
  linkItems,
  deliveryServices,
  handleToggleAccordion,
  handleAddItemToLinkedGroup,
}) => {
  const includeDeliveryService = (deliveryServiceName: DeliveryServiceName) =>
    deliveryServices.includes(deliveryServiceName);

  return (
    <CmBox borderTopWidth="1px" bg="white">
      {linkItems.map((LinkItemsDividedByDeliveryService, index) => {
        const { delivery_service_name, linked_store_items } =
          LinkItemsDividedByDeliveryService;
        const isIncludeDeliveryServiceName = includeDeliveryService(
          delivery_service_name
        );
        return (
          <CmBox
            key={delivery_service_name}
            borderTopWidth={index > 0 ? '1px' : ''}
          >
            <AccordionHeader
              onClick={() => handleToggleAccordion(delivery_service_name)}
              isExpanded={isIncludeDeliveryServiceName}
              name={delivery_service_name}
            />
            {isIncludeDeliveryServiceName &&
              linked_store_items.map((linkItem, index) => (
                <AccordionItem
                  key={`${delivery_service_name}_${linkItem.item_name}_${index}`}
                  deliveryServiceName={delivery_service_name}
                  {...{
                    isDisabledAddButton,
                    uniqueLinkedStoreItemIdsByGroups,
                    handleAddItemToLinkedGroup,
                    linkItem,
                  }}
                />
              ))}
          </CmBox>
        );
      })}
    </CmBox>
  );
};
